import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'

import BodyText from 'LuxKit/Typography/BodyText'
import Label from 'LuxKit/Label/Label'
import Pane from 'components/Common/Pane/Pane'
import Group from 'components/utils/Group'
import NumberRating from 'components/Common/NumberRating/NumberRating'

const Container = styled(Pane)`
  padding: ${rem(16)} ${rem(20)};
`

const RatingWrapper = styled.div`
  flex-shrink: 0;
  white-space: nowrap;
`

interface Props {
  content: string
  score: number
  reviewsTotal: number
}

function OfferPageReviewAiSummary({
  content,
  score,
  reviewsTotal,
}: Props) {
  const intl = useIntl()

  return (
    <Container background="neutral-seven">
      <Group direction="horizontal" gap={20} verticalAlign="start">
        <RatingWrapper>
          <NumberRating
            link
            rating={score}
            total={reviewsTotal}
            variant="xl"
            hideLabel
            layout="vertical"
          />
        </RatingWrapper>
        <Group direction="vertical" gap={8}>
          <Group direction="horizontal" gap={8} verticalAlign="center">
            <BodyText variant="large" weight="bold">
              {intl.formatMessage({
                id: 'uUdB4FuUUHKUZ8vXWn2C',
                defaultMessage: 'What guests say',
                description: 'Heading title for the AI-generated guest review summary section on the offer page',
              })}
            </BodyText>
            <Label kind="secondary" variant="grey">
              {intl.formatMessage({
                id: 'ZPTVk6CBc0FPQas1IpDb',
                defaultMessage: 'AI summary',
                description: 'Badge label indicating the review summary content is AI-generated on the offer page',
              })}
            </Label>
          </Group>
          <BodyText variant="medium" colour="neutral-two">{content}</BodyText>
        </Group>
      </Group>
    </Container>
  )
}

export default React.memo(OfferPageReviewAiSummary)
